export default __webpack_public_path__ + "static/media/triangle-arrow.b252c494.svg";